__webpack_require__.p = "/wp-content/themes/codebuddys/react-app/";